import { PyramidSettings } from 'src/app/models/pyramid.interface';
import { PyramidPaths } from 'src/app/models/pyramid.enum';

export const pyramidSummerPeakSettings: PyramidSettings = {
  title: 'Åtgärder mot "sommartopp"',
  path: PyramidPaths.SummerPeak,
};
